import React from 'react';
import { Container } from '../../components/ui/Container';
export function CodeOfConduct() {
  return <>
      <section className="py-16 md:py-24" data-id="element-3819" data-mp="1tlxzzac7rcd4">
        <Container data-id="element-3820" data-mp="1titmtngrt6ab">
          <div className="max-w-4xl mx-auto" data-id="element-3821" data-mp="1oltl1oqyepp0">
            <h1 className="font-display text-4xl md:text-6xl text-ink-900 leading-tight" data-id="element-3822" data-mp="1okiczcqh6vs3">
              Code of Conduct
            </h1>
            <p className="mt-4 text-ink-500" data-id="element-3823" data-mp="1kmkne8ssm7o6">
              <strong data-id="element-3824" data-mp="1fm6qnmwn6k5g">Last updated:</strong> February 1, 2026
            </p>

            <div className="mt-8 rounded-2xl border border-sage-200 bg-sage-50 px-6 py-5 shadow-soft" data-id="element-3825" data-mp="1atwu3o10ulu7">
              <p className="text-ink-700 leading-relaxed" data-id="element-3826" data-mp="15usmh1tqww5z">
                We hold ourselves to the standard of amanah (trust) and adab in
                all conduct, ensuring that our professional actions reflect the
                highest ethical values.
              </p>
            </div>

            <div className="mt-10 space-y-8 text-ink-700 leading-relaxed" data-id="element-3827" data-mp="rv112g0wgdhy">
              <p data-id="element-3828" data-mp="rxx1cb07ze9k">
                This Code of Conduct applies to all stakeholders, including
                staff, educators, volunteers, partners, and program
                participants.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3829" data-mp="1l2le03gysb8e">
                Expected Behavior
              </h2>
              <p data-id="element-3830" data-mp="1p4yfugslbozw">
                We expect all individuals associated with the Hub to
                demonstrate:
              </p>
              <p data-id="element-3831" data-mp="2crepxp0c32c6">
                <strong data-id="element-3832" data-mp="2hsly3p6e23jd">• Respect:</strong> Treating all individuals with
                dignity and respect.
              </p>
              <p data-id="element-3833" data-mp="23tmbso6cm0qd">
                <strong data-id="element-3834" data-mp="23s1fat0h47pv">• Inclusion:</strong> Upholding cultural sensitivity and
                fostering a welcoming, supportive environment for all children
                and families.
              </p>
              <p data-id="element-3835" data-mp="scuufewkch4w">
                <strong data-id="element-3836" data-mp="sccvgaiinota">• Integrity:</strong> Acting with high ethical and
                professional standards.
              </p>
              <p data-id="element-3837" data-mp="2z1n74r1upljr">
                <strong data-id="element-3838" data-mp="2z26drbm1wnih">• Boundaries:</strong> Maintaining appropriate
                communication and professional boundaries.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3839" data-mp="2u3lkxx94p642">
                Prohibited Conduct
              </h2>
              <p data-id="element-3840" data-mp="2larx3bfm8yel">The following behaviors are strictly prohibited:</p>
              <p data-id="element-3841" data-mp="2l8fbmoang5ws">• Discrimination, harassment, or bullying of any kind.</p>
              <p data-id="element-3842" data-mp="2gd01o7friu5n">• Abuse of authority or position.</p>
              <p data-id="element-3843" data-mp="2bclvyw1mvwas">• Inappropriate or sexually suggestive communication.</p>
              <p data-id="element-3844" data-mp="2beortwpgwjnf">
                • Misuse or theft of organizational resources or intellectual
                property.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3845" data-mp="22cflzk559egd">
                Violations
              </h2>
              <p data-id="element-3846" data-mp="4lcn27qyxwz6">
                Violations of this Code will be investigated and may result in
                immediate removal from programs, termination of employment, or
                severance of partnership agreements.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>;
}